import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSession } from "@user-management-context/primary/hooks/use-session";
import { useAuthErrorRedirect } from "@user-management-context/primary/user/logout/use-auth-error-redirect";
import { SpinnerWithText } from "@shared-kernel/primary/shared/ui/spinner";

export const ProtectedRoute = () => {
  const { status, user } = useSession();
  const { pathname, search } = useLocation();

  useAuthErrorRedirect();

  // Terminated wins regardless of stale user data.
  if (status === "terminated") {
    // `search` is part of the destination: a deep link mailed to a logged-out
    // user (`/payouts?year=2026`) would otherwise lose its query string on the
    // way through the login page.
    return <Navigate to="/login" replace state={{ from: `${pathname}${search}` }} />;
  }

  // Block on sync only when no user is loaded yet (initial bootstrap).
  // Once the user is loaded, background re-syncs must not unmount the
  // subtree — otherwise any page that triggers a syncSession on mount
  // would loop (mount → syncing → unmount → active → remount → ...).
  if (!user) {
    return (
      <div className="flex h-screen items-center justify-center">
        <SpinnerWithText text="Chargement..." />
      </div>
    );
  }

  return <Outlet />;
};
